module.exports = __webpack_public_path__ + "static/media/ic-benefits.6d15e20c.svg";